import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { GeneratedBranchInoviceConsultantList } from "./GeneratedBranchInoviceConsultantList";
import { InputNumber } from 'primereact/inputnumber';
import { BranchInvoice } from "./BranchInvoice";
import { Toast } from "primereact/toast";

interface IProps {
    toast?: any
}

export interface GeneratedBranchInvoice {
    id?: number,
    branchID?: number,
    userType?: number,
    branchInvoiceAmount?: number,
    branchInvoiceCalculatedAmount?: number,
    payment_Status?: string,
    payment_Received_Amount?: number,
    is_Payment_Received?: boolean,
    payment_Received_Date?: Date,
    createdOn?: Date,
    company_Name?: string,
    branchName?: string,

}

export const GeneratedBranchImvoice = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<GeneratedBranchInvoice>, loading: boolean });
    const [updatePaymentStatus, setUpdatePaymentStatus] = useState({ singleData: {} as GeneratedBranchInvoice, open: false } as { singleData: GeneratedBranchInvoice, open: boolean });
    const [madal, setModal] = useState({ id: 0, singleData: {}, open: false } as { id: number, singleData: GeneratedBranchInvoice, open: boolean });
    const dt: any = useRef<any>(null);
    const toast = useRef<any>(null);

    const header = () => {
        return (
            <>
            </>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/generatedBranchWiseInvoices", "GET", null, null, props.toast);
        if (response) {
            const data: GeneratedBranchInvoice[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                <Button icon="pi pi-refresh" className="p-button-primary" onClick={() => loadTableData()} />
            </div>
        );
    }


    const openConsultantList = async (rowData: GeneratedBranchInvoice) => {
        if (rowData.id !== undefined && rowData.id !== null && rowData.id !== 0) {
            setModal({ id: rowData.id, singleData: rowData, open: true });
        }
        // const response = await Fetch("InvoiceTracking/generatedBranchWiseInvoicesConsultantList", "GET", null, `invoiceID=${id}`, props.toast);
        // if (response) {
        //     const data: any[] = await response.json();
        //     console.log(data);
        // }
    }

    const actionButton = (rowData: GeneratedBranchInvoice) => {
        return <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => setUpdatePaymentStatus({ singleData: rowData, open: true })} />
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const updateRow = async (data: GeneratedBranchInvoice) => {
        const newData: GeneratedBranchInvoice = {
            id: data.id,
            payment_Status: data.payment_Status,
            payment_Received_Amount: data.payment_Received_Amount,
        };
        const response = await Fetch("InvoiceTracking/updateInvoiceGeneratedBranchWiseIncentiveCalculation", "PUT", newData, null, props.toast);
        if (response) {
            props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Follow Up Call History Added Successfully' });
        } else {
            props.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Add Follow Up Call History' });
        }
    }

    const onCellEditComplete = (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'price':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };

        const paymentStatus: string = Number(rowData.branchInvoiceAmount || "0") === Number(rowData.payment_Received_Amount || "0") ? "Paid" : (Number(rowData.branchInvoiceAmount || "0") > Number(rowData.payment_Received_Amount || "0") ? "Balance" : "Over Payment");
        rowData['payment_Status'] = paymentStatus;
        updateRow({ id: rowData.id, payment_Received_Amount: rowData.payment_Received_Amount, payment_Status: paymentStatus });
    };

    // const priceEditor = (options: ColumnEditorOptions) => {
    //     return <InputNumber value={options.value} onValueChange={(e: any) => options.editorCallback(e.value)} mode="currency" currency="USD" locale="en-US" onKeyDown={(e) => e.stopPropagation()} />;
    // };

    const cellEditor = (options: ColumnEditorOptions) => {
        /*
        {
    node?: any;
    rowData: any;
    value: any;
    column: Column;
    field: string;
    rowIndex: number;
    frozenRow?: boolean;
    props: any;
    editorCallback?(val: any): void;
    }
        */
        // if (options.field === 'payment_Received_Amount') return priceEditor(options);
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };

        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', outline: 'none' }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, []);
    //BranchConsultantGeneratedInvoice.tsx
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                dataKey="id"
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                editMode="cell"
            >
                <Column field="userType" header="Service Type" body={(rowData: GeneratedBranchInvoice) => <p>{rowData.userType === 2 ? "Sales" : "Recruiter"}</p>} />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="branchInvoiceCalculatedAmount" header="Total Amount ($)" body={(rowData: GeneratedBranchInvoice) => <p>{rowData?.branchInvoiceCalculatedAmount}</p>} />
                <Column field="branchInvoiceAmount" header="Branch Amount ($)" body={(rowData: GeneratedBranchInvoice) => <p className="cursor-pointer text-cyan-700 underline" onClick={() => openConsultantList(rowData)}>{rowData?.branchInvoiceAmount}</p>} />
                <Column field="createdOn" header="Created On" body={(rowData: GeneratedBranchInvoice) => {
                    let date;
                    if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                <Column field="payment_Status" header="Status" />
                <Column field="payment_Received_Amount" header="Received Amount ($)" body={(rowData) => <p>{rowData.payment_Received_Amount}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="payment_Received_Date" header="Received Date" body={(rowData: GeneratedBranchInvoice) => {
                    let date;
                    if (rowData.payment_Received_Date) date = format(new Date(rowData.payment_Received_Date), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                {/* <Column header="Action" body={actionButton} /> */}
            </DataTable>
            <GeneratedBranchInoviceConsultantList open={madal.open} singleData={madal.singleData} id={madal.id} setModal={setModal} toast={props.toast} />
            <BranchInvoice open={updatePaymentStatus.open} onClose={() => {
                setUpdatePaymentStatus({ singleData: {} as GeneratedBranchInvoice, open: false });
                loadTableData();
            }} singleData={updatePaymentStatus.singleData} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}